import { useDispatch } from "react-redux";

import { confirmEntry } from "../../../actions/entry";
import { T } from "../../util/t";
import { AutoProgressButton } from "../forms/fields/AutoProgressButton";
import { makeStyles } from "../../providers/makeStyles";
import { useError } from "../../../hooks/useNotifications";
import { useLocalizationContext } from "../../providers/LocalizationProvider";
import { CreditCard } from "@mui/icons-material";

export const useConfirmEntry = (entry) => {
    const dispatch = useDispatch();
    const { notifyError, notifyResponseError } = useError();
    const { translate } = useLocalizationContext();

    return (e) => {
        e.stopPropagation();
        return dispatch(confirmEntry(entry.eventDivisionId, entry.id)).catch(
            (e) => {
                if (e.response?.status === 402) {
                    notifyError(
                        translate("athlete_payment_failed", {
                            name: entry.athlete.name,
                        }),
                    );
                } else {
                    notifyResponseError(e);
                }
            },
        );
    };
};

export const useStatusButtonStyles = makeStyles((theme) => ({
    button: {
        whiteSpace: "nowrap",
        [theme.breakpoints.down("md")]: {
            minWidth: "auto",
        },
    },
}));
export const ConfirmButton = ({ entry }) => {
    const confirm = useConfirmEntry(entry);
    const classes = useStatusButtonStyles();

    return (
        <AutoProgressButton
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={confirm}
            startIcon={entry.payment?.status === "setup" && <CreditCard />}
        >
            <T>Confirm</T>
        </AutoProgressButton>
    );
};
